<template>
  <div class="community-list">

      <community-list-skeleton v-if="loading"></community-list-skeleton>

      <div v-else>

          <div class="community-list-header">
              <div class="search-box">
                  <van-search shape="round" class="header-search" left-icon="/static/bytx/public/search_black.svg" @click="search" v-model="value" placeholder="查找救助项目"/>
              </div>
          </div>

          <div class="community-list-container">
              <div class="tags">
                  <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                      <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
                  </van-tabs>
                  <div class="clear"></div>
              </div>

              <div v-if="list && list.length > 0" class="community-list-section">
                  <div @click="go_detail(item)" v-for="(item,index) in list" :key="item.id">
                      <van-row v-if="item.top === 1 && index == 0" class="community-list-section-box" style="padding: 0;">
                          <div class="community-list-section-top">
                              <div class="community-list-section-box" style="border: 0">
                                  <van-image
                                      fit="cover"
                                      class="community-list-section-left-img"
                                      :src="item.cover_img"
                                      width="100%"
                                      height="100%"
                                  />
                                  <img class="top-tag" src="/static/bytx/tag_live_best_icon.svg" alt="">
                                  <div class="community-list-section-title-box">
                                      <div class="community-list-section-title">
                                          {{item.title.length > 20 ? item.title.substring(0,20)+'...' : item.title}}
                                      </div>
                                      <div>
                                          <div class="community-list-section-info">{{item.desc ? item.desc : '为爱点亮希望'}}</div>
                                          <img class="community-list-section-icon" src="/static/bytx/welfare_sqjz_btn.svg"  @click.stop="applyHelp(item)" alt="">
                                      </div>
                                      <div class="clear"></div>
                                  </div>
                              </div>
                              <div class="clear"></div>
                          </div>
                      </van-row>
                      <van-row v-else class="community-list-section-box">
                          <div class="community-list-section-left">
                              <van-image
                                  fit="cover"
                                  class="community-list-section-left-img"
                                  :src="item.cover_img"
                                  width="100%"
                                  height="100%"
                              />
                          </div>
                          <div class="community-list-section-right">
                              <div class="community-list-section-right-title">
                                  {{item.title.length > 22 ? item.title.substring(0,22)+'...' : item.title}}
                              </div>
                              <div class="community-list-section-info">{{item.desc ? item.desc : '为爱点亮希望'}}</div>
                              <div class="community-list-section-right-detail">
                                  <div>
                                      <div class="help-content-box-other-text-bot">
                                          <img src="/static/bytx/public/welfare_help_icon_2.svg">
                                          <span @click.stop="applyHelp(item)">申请救助</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="clear"></div>
                      </van-row>
                  </div>
              </div>
              <div class="van-list__finished-text" v-if="list.length > 6 && page === total_page">已到底部</div>
              <div v-else-if="list.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
              <van-empty v-else-if="list.length === 0" description="" image="/static/img/pic_blank_content.svg" >
                  <template slot="description">
                      <div style="text-align: center">博医同行持续更新中…</div>
                      <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                      <div style="text-align: center;margin-top: 24px">
                          <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                              返回首页
                          </van-button>
                      </div>
                  </template>
              </van-empty>
          </div>

          <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
              <template slot="title">
                  <div class="close-pop" @click="closeApplyForm">
                      <img src="/static/bytx/popup_close_icon.svg" alt="">
                  </div>
                  <h3 v-if="!detail.isApply">申请公益救助</h3>
                  <h3 v-else>您已申请，无需重复提交！</h3>
              </template>
              <div class="clear"></div>
              <div v-if="!detail.isApply">为核实申请信息，为您申请公益救助项目，需您完善真实信息。</div>
              <div v-else style="text-align: center">请将项目名发给小助手，获取报名表或链接</div>
              <div v-if="!detail.isApply" align="center" style="margin-top: 12px;color: #9D9D9D">
                  <van-button class="clinic-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                      立即填写
                  </van-button>
              </div>
              <div v-else style="text-align: center">
                  <img width="220" src="/static/qrcode/gyjz.png" alt="">
                  <div>长按识别添加</div>
              </div>
          </van-dialog>

          <div class="pre-page">
              <img src="/static/bytx/public/welfare_back_btn.svg" @click="$router.push({name:'welfare-zone'})">
          </div>
      </div>
  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import communityListSkeleton from "@/skeleton/articleListSkeleton"
    import checkLogin from "../../../mixins/checkLogin";
    export default {
        name: 'community-list',
        mixins: [checkLogin],
        components :{
            'community-list-skeleton' : communityListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                banners: [],
                categories: [
                    {id:0,name: "全部"},
                    {id:1,name:'经济救助'},
                    {id:2,name:'医疗救助'},
                    {id:3,name:'生活帮扶'},
                    /*{id:3,name:'教育助学'},
                    {id:4,name:'非血缘/脐带救助'},*/
                ],
                detail:{},
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,
                formData: {
                    name:"",
                    mobile:"",
                    sex:"男",
                    identity_name:"患者本人",
                    identity:1,
                },
                id:0,

                applyFormDialog:false,
                openFeedback:false,
                record_id: 0
            }
        },
        methods: {
            onSearch(){
                this.fetch('list')
            },
            onCancel() {
                this.value = ""
                this.fetch("list")
            },
            fetch(scene) {
                if (scene === 'list') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        type : this.category_id,
                    }
                    Interface.getData('get', Interface.community.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    type : this.category_id,
                }
                Interface.getData('get', Interface.community.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                sessionStorage.setItem("community_search_channel",this.category_index)

                this.category_id = this.categories[this.category_index].id
                this.fetch('list')
            },
            go_detail(item){
                if(item.id > 46){
                    this.$router.push({
                        name : 'community-detail-new',
                        params : {
                            id : item.id
                        }
                    })
                }else{
                    this.$router.push({
                        name : 'community-detail',
                        params : {
                            id : item.id
                        }
                    })
                }
            },
            applyHelp(item) {
                this.id = item.id
                Interface.getData('get', Interface.community.detail + item.id).then((res) => {
                    if (res.code == 0) {
                        this.detail = res.data
                        this.applyFormDialog = true
                    }
                })
            },
            goLogin(){
                //申请
                let user = localStorage.getItem("user");
                user = JSON.parse(user)
                sessionStorage.setItem("back-url", this.$route.path)
                sessionStorage.setItem("apply",JSON.stringify({
                    apply:'community',apply_id:this.id
                }))
                this.goAddInfo(user)
            },
            apply(){
                if(!this.checkPhone(this.formData.mobile)){
                    this.$toast.fail("手机号格式不正确")
                    return
                }
                switch (this.formData.identity_name){
                    case "患者本人":
                        this.formData.identity=1;
                        break;
                    case "患者家属":
                        this.formData.identity=2;
                        break;
                    case "医务工作者":
                        this.formData.identity=3;
                        break;
                    default:
                        this.formData.identity=4;
                        break;
                }

                let params = {
                    ...this.formData
                }
                Interface.getData('get', Interface.user.apply_community+this.id,params).then((res) => {
                    if(res.code == 0){
                        this.openFeedback = true
                        this.applyFormDialog = false
                    }
                })
            },

            closeApplyForm(){
                this.applyFormDialog = false
            },
            changeIdentity(){
                this.$forceUpdate()
            },
            search() {
                this.$router.push({name:'search',query:{form:"community", pageType: 6 }})
                Interface.mFootPrint(0,76,0,6,0,0,0,'救助项目-搜索')
                // Interface.footPrint(25,0,0,"点击公益首页搜索")
            },
        },
        created() {
            sessionStorage.removeItem("search_data")
            let search_channel = sessionStorage.getItem("community_search_channel")
            if (search_channel != null){
                this.category_index = parseInt(search_channel)
                this.changeCategory()
            }else{
                this.category_index = 0
                this.changeCategory()
            }
            Interface.getShareInfo(this,"公益救助")
          Interface.getData('post',Interface.footprint, {
            id: 0,
            type: 56,
            content_type: 0,
            page_type: 6,
            source_type: 0,
            parent_id: 0,
            record_id: 0,
            title: '救助项目列表'
          }).then( (res) => {
            if (res.code == 0) {
              this.record_id = res.data.record_id
            }
          })
            Interface.CoFootPrint(17)
        },
        beforeRouteLeave(to, from, next) {
          if (this.record_id) {
            Interface.mFootPrint(0, 56,0, 6, 0, 0,this.record_id,'救助项目列表')
          }
          next()
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/list/index.vue